"use strict";
const OBJECTIVE_COMPLETION_CRITERIA = {
    TASKS_ARE_COMPLETE: 'Tasks are complete',
    MILESTONES_ARE_COMPLETE: 'Milestones are complete',
    MILESTONES_AND_TASKS_ARE_COMPLETE: 'Milestones + tasks are complete',
    MANUALLY_MARKED_AS_COMPLETE: 'Manually marked as complete',
};
const OBJECTIVE_VISIBILITY = {
    INTERNAL: 'Internal',
    CUSTOMER_FACING: 'Customer Facing',
};
const OBJECTIVE_STATUS = {
    NOT_STARTED: 'Not Started',
    IN_PROGRESS: 'In Progress',
    BLOCKED: 'Blocked',
    ON_HOLD: 'On Hold',
    CANCELLED: 'Cancelled',
    COMPLETED: 'Completed',
    FAILED: 'Failed',
};
const TASKS_HANDLING_ON_DELETE_OBJECTIVE = {
    DELETE: 'delete',
    ASSIGN_TO_OTHER_OBJECTIVE: 'assignToOtherObjective',
    REMOVE_FROM_OBJECTIVE: 'removeFromObjective',
};
module.exports = {
    OBJECTIVE_COMPLETION_CRITERIA,
    OBJECTIVE_VISIBILITY,
    OBJECTIVE_STATUS,
    TASKS_HANDLING_ON_DELETE_OBJECTIVE,
};
//# sourceMappingURL=consts.js.map